import React, { useEffect, useState } from 'react'
import { SearchSVG } from '@/Component/Common/SVGs/CommonSVG';

const SearchInput = React.forwardRef((props: any, ref) => {
    const { inputProps, customClass, setSearch, customInputMainClass, setParams, onFocus, onBlur, value, setSearchData, translations, onKeyDown } = props;
    const [tc, setTc] = useState<NodeJS.Timeout | null>(null);
    const [searchValue, setSearchValue] = useState('');

    const onChange = (text: any) => {
        if (tc) clearTimeout(tc);
        setSearchValue(text);
        setTc(setTimeout(() => {
            setSearchData && setSearchData(text);
            setSearch && setSearch(text);
            setParams && setParams((prev) => ({ ...prev, page: 1 }))
        }, 600));
    };

    useEffect(() => {
        setSearchValue(value);
    }, [value]);

    return (
        <div className={`${customInputMainClass} relative`}>
            <div className="absolute start-4 inset-y-0 flex items-center pointer-events-none z-20">
                <SearchSVG />
            </div>
            <input ref={ref} {...inputProps} onChange={(e) => onChange(e.target.value)} onFocus={onFocus} onKeyDown={onKeyDown} value={searchValue} onBlur={onBlur} className={`${customClass} pl-10 w-full bg-lightGray/30  focus:outline-primary border border-lightGray placeholder:text-black/50 py-3 px-4 text-sm rounded-3xl text-black/75`} placeholder={`${translations?.search}...`} />
        </div>
    )
});

export default SearchInput
